import { tokens } from '@design';
/**
 * Unified Comment System Types
 * Used across Goals, KPIs, Initiatives, and Services
 */

export type UserType = 'strategy_team' | 'org_employee' | 'superuser' | 'executive';

export interface CommentData {
  id: number;
  name: string;
  initials: string;
  date: string;
  text: string;
  avatarColor: string;
  showMenu: boolean;
  isEdited?: boolean;
  originalText?: string;
  userType?: UserType;
}

export interface CommentCardProps {
  comment: CommentData;
  onEdit?: (comment: CommentData) => void;
  onDelete?: (id: number) => void;
}

export interface AddCommentInputProps {
  onSubmit: (text: string) => void;
  onCancel: () => void;
  editingComment?: CommentData | null;
}

export interface CommentSectionProps {
  title?: string;
  comments: CommentData[];
  showAddComment: boolean;
  editingComment: CommentData | null;
  /** Hide the add comment button (for view-only users like executive) */
  hideAddButton?: boolean;
  onAddClick: () => void;
  onEditComment: (comment: CommentData) => void;
  onDeleteComment: (id: number) => void;
  onSubmitComment: (text: string) => void;
  onCancelComment: () => void;
}

// User type configuration - matches Figma design exactly
export const USER_TYPE_CONFIG: Record<UserType, { label: string; color: string; bgColor: string }> = {
  strategy_team: { label: 'فريق الاستراتيجية', color: '#0F9CD8', bgColor: tokens.colors.raw.amber["100"] }, // Figma: Gold avatar
  org_employee: { label: 'موظف الجهة', color: '#9467BD', bgColor: '#F3E8FF' }, // Figma: Purple avatar
  superuser: { label: 'مدير النظام', color: '#2563EB', bgColor: '#DBEAFE' },
  executive: { label: 'تنفيذي', color: '#059669', bgColor: '#D1FAE5' },
};

// Helper to get initials from user type
export const getInitialsFromUserType = (userType: UserType): string => {
  switch (userType) {
    case 'strategy_team':
      return 'ف إ';
    case 'org_employee':
      return 'م ج';
    case 'superuser':
      return 'م ن';
    case 'executive':
      return 'ت ف';
    default:
      return 'م ج';
  }
};

// Helper to get avatar color from user type
export const getAvatarColorFromUserType = (userType: UserType): string => {
  return USER_TYPE_CONFIG[userType]?.color || tokens.colors.raw.blue["500"];
};
